import { contactPageLink, legalApp, legalLink } from "@serophin/shared";

export const NOTTLDR_LEGAL = legalApp({ id: "nottldr", product: "!tldr", site: "www.nottldr.com", effectiveDate: "2026-10-16" });

export const CONTACT_US = contactPageLink(NOTTLDR_LEGAL, "contact us");

export const PRIVACY_POLICY = legalLink("Privacy Policy", "/privacy");

export const COOKIES_ANCHOR = "cookies-and-tracking-technologies";
